import Divider, { OldDivider } from "./Divider";

export { OldDivider };
export default Divider;
